import { FormControl, FormHelperText, Typography } from "@mui/material";
import { ErrorMessage, Field, FieldProps } from "formik";
import React from "react";
import Checkbox from "../../FormComponents/Checkbox";

interface Props {
  readonly label: string;
  readonly name: string;
  readonly value: string | number;
}

function FormikCheckbox({ label, name, value, ...props }: Props) {
  return (
    <FormControl fullWidth>
      <Field name={name}>
        {({ field, form }: FieldProps) => (
          <Checkbox
            {...props}
            label={label}
            value={value}
            checked={field.value === value}
            onChange={() =>
              field.value === value
                ? form.setFieldValue(name, "")
                : form.setFieldValue(name, value)
            }
          />
        )}
      </Field>
      <ErrorMessage
        component={FormHelperText}
        name={name}
        render={(msg) => (
          <Typography
            component="span"
            className="px-2 font-sans text-sm font-medium text-default-error-7"
          >
            {msg}
          </Typography>
        )}
      />
    </FormControl>
  );
}

export default FormikCheckbox;
